module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "settings includes-header"
  }, [_vm._m(0), _c('group', {
    attrs: {
      "user": _vm.user,
      "finished": true
    },
    on: {
      "done": _vm.done
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "page-header settings-header settings-header--finished"
  }, [_c('img', {
    staticClass: "image--balloons",
    attrs: {
      "src": "/build/img/balloons.png",
      "srcset": "/build/img/balloons@2x.png 2x",
      "width": "135",
      "alt": "Ballonnen"
    }
  }), _c('h1', [_vm._v("Het jaar zit er weer op!")]), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b05e1f8","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/settings/Archived.vue
// module id = elzP
// module chunks = 0 1